import { render, staticRenderFns } from "./branches.vue?vue&type=template&id=965d5a9e&scoped=true&"
import script from "./branches.vue?vue&type=script&lang=js&"
export * from "./branches.vue?vue&type=script&lang=js&"
import style0 from "./branches.vue?vue&type=style&index=0&id=965d5a9e&lang=scss&scoped=true&"
import style1 from "./branches.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965d5a9e",
  null
  
)

export default component.exports